import { render } from "./SocialSignin.vue?vue&type=template&id=0bc9a4ca&scoped=true&ts=true"
import script from "./SocialSignin.vue?vue&type=script&lang=ts"
export * from "./SocialSignin.vue?vue&type=script&lang=ts"

import "./SocialSignin.vue?vue&type=style&index=0&id=0bc9a4ca&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc9a4ca"]])

export default __exports__